module.exports = __webpack_public_path__ + "media/src/assets/Images/Bandes-f9d4a857844849bb422dfa043b71af24.svg";